/* op-variant-badge: update the product page gallery badge on variant change (snippets/op-variant-badge.liquid) */
(() => {
  if ( window.opVariantBadge ) return;
  window.opVariantBadge = true;

  document.addEventListener('krown:variant:change', event => {
    const variant = event.detail && event.detail.variant;
    if ( ! variant ) return;

    document.querySelectorAll('[data-op-variant-badge]').forEach(badge => {
      const mapElm = badge.querySelector('[data-op-variant-badge-map]');
      if ( ! mapElm ) return;
      let map;
      try {
        map = JSON.parse(mapElm.textContent);
      } catch (error) {
        return;
      }
      const texts = map[String(variant.id)];
      if ( ! texts ) return;

      const [size, qty] = texts;
      const sizeElm = badge.querySelector('[data-op-badge-size]');
      const qtyElm = badge.querySelector('[data-op-badge-qty]');
      sizeElm.textContent = size;
      sizeElm.hidden = ! size;
      qtyElm.textContent = qty;
      qtyElm.hidden = ! qty;
      badge.hidden = ! size && ! qty;
    });
  });
})();
